var msPerSecond = 1000;
var msPerMinute = msPerSecond * 60;
var msPerHour = msPerMinute * 60;
var msPerDay = msPerHour * 24;
var TimeSpan = /** @class */ (function () {
    function TimeSpan(years, months, days, hours, minutes, seconds, milliseconds, totalMilliseconds) {
        this.years = years;
        this.months = months;
        this.days = days;
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.milliseconds = milliseconds;
        this.totalMilliseconds = totalMilliseconds;
    }
    Object.defineProperty(TimeSpan.prototype, "totalSeconds", {
        get: function () {
            return Math.floor(this.totalMilliseconds / msPerSecond);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "totalMinutes", {
        get: function () {
            return Math.floor(this.totalMilliseconds / msPerMinute);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "totalHours", {
        get: function () {
            return Math.floor(this.totalMilliseconds / msPerHour);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "totalDays", {
        get: function () {
            return Math.floor(this.totalMilliseconds / msPerDay);
        },
        enumerable: false,
        configurable: true
    });
    return TimeSpan;
}());
export { TimeSpan };
